<!-- Filename: app.component.html -->
<!-- Shell-Komponente für Angular Routing – zeigt Router-Content und die
     app-weiten Overlays. Das Popup gehört hierher und nicht in eine Seite:
     eine Nachricht erreicht den Nutzer auch dann, wenn er gerade im
     Task-Editor oder im Daily Scrum arbeitet. -->

<router-outlet></router-outlet>

<app-message-popup></app-message-popup>

<!-- Anfrage per @ (Alt+P) und die wiederkehrende Erinnerung — _40 #223.
     Nicht auf den Anmeldeseiten: dort gibt es noch keine Sitzung. -->
@if (mitAnfragen()) {
  <app-ask-panel></app-ask-panel>
  <app-request-reminder></app-request-reminder>
}
